import { render } from "./DeliveryItem.vue?vue&type=template&id=f361633a"
import script from "./DeliveryItem.vue?vue&type=script&lang=js"
export * from "./DeliveryItem.vue?vue&type=script&lang=js"
script.render = render

export default script